/// <amd-module name="SearchUI/Components/WikiSearchResultComponent/WikiSearchResultItem.Props" />

import { WikiResult } from "SearchUI/Contracts/Search.SharedLegacy";

export interface WikiSearchResultProps {

    /**
    * Content to be rendered in row.
    * ToDo: Remove implict type.
    */
    result: WikiResult | any;

    /**
    * Sanitize html function.
    */
    sanitizeHtml(html: string): string;

    /**
    * Url for corresponding wiki page.
    */
    wikiPageUrl: string;

    /**
    * rowSubTitle for component.
    */
    rowSubTitle: JSX.Element;

    /**
    * optional prop to open the link in new tab
    */
    openLinkInNewTab?: boolean;	

	/**
	* On click of file name
	*/
	onFileNameClicked?: (link: string, evt: React.MouseEvent<HTMLAnchorElement> | React.KeyboardEvent<HTMLAnchorElement>) => void;
}
